import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import EventDetails from './EventDetails';
import { getEventDetailsInitiate } from '../../actions/company';

const mapStateToProps = state => {
  const eventData = _get(state, 'company.eventData', {});
  const creditTransactions = _get(eventData, 'credit_transactions', []);
  const eventDetails = _get(eventData, 'event_details', {});
  const programDetails = _get(eventData, 'program_details', {});

  return {
    eventDetails,
    programDetails,
    creditTransactions,
    fetchingEventDetails:
      _get(state, 'apiState.GET_EVENT_DETAILS.isFetching', true) &&
      !_get(state, 'apiState.GET_EVENT_DETAILS.isIdle', false),
    fetchedEventDetails: _get(
      state,
      'apiState.GET_EVENT_DETAILS.success',
      true,
    ),
  };
};

const mapDispatchToProps = dispatch => ({
  getEventDetails: payload => dispatch(getEventDetailsInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EventDetails);
